// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 9845); hand-edits allowed (see docs/architecture.md)

/** `this.CRAFT_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_CRAFT_DEF(): any {
  return new Array<any>(88, {
    "req": 0,
    "result": "unfail_bazooka",
    "ingr": [2, "bazooka", "obj_small_expl"]
  }, {
    "req": 1,
    "result": "fire_bazooka",
    "ingr": [2, "bazooka", "obj_napalm_cont"]
  }, {
    "req": 3,
    "result": "rj46",
    "ingr": [3, "fire_bazooka", "upg_mortar", "obj_hard_jacket"]
  }, {
    "req": 0,
    "result": "poison_bazooka",
    "ingr": [2, "bazooka", "obj_poison_cont"]
  }, {
    "req": 2,
    "result": "ap_bazooka",
    "ingr": [2, "unfail_bazooka", "obj_hard_jacket"]
  }, {
    "req": 3,
    "result": "ap_bazooka2",
    "ingr": [5, "ap_bazooka", "ap_bazooka", "obj_hard_jacket", "obj_hard_jacket", "obj_big_expl"]
  }, {
    "req": 3,
    "result": "howitzer",
    "ingr": [2, "ap_bazooka2", "obj_plasma_mod"]
  }, {
    "req": 2,
    "result": "multi_bazooka",
    "ingr": [6, "unfail_bazooka", "unfail_bazooka", "unfail_bazooka", "unfail_bazooka", "obj_small_cell", "obj_fuel"]
  }, {
    "req": 2,
    "result": "gravity_grenade",
    "ingr": [6, "grenade", "obj_eg_generator", "obj_eg_generator", "obj_eg_generator", "obj_eg_generator", "obj_eg_generator"]
  }, {
    "req": 0,
    "result": "unfail_grenade",
    "ingr": [2, "grenade", "obj_small_expl"]
  }, {
    "req": 2,
    "result": "holy_hand_grenade",
    "ingr": [3, "unfail_grenade", "obj_big_expl", "obj_laser_mod"]
  }, {
    "req": 3,
    "result": "super_hhg",
    "ingr": [2, "holy_hand_grenade", "obj_pulse_mod"]
  }, {
    "req": 3,
    "result": "holy_strike",
    "ingr": [4, "holy_hand_grenade", "holy_hand_grenade", "holy_hand_grenade", "obj_radio"]
  }, {
    "req": 1,
    "result": "plasma_grenade",
    "ingr": [2, "grenade", "obj_plasma_mod"]
  }, {
    "req": 2,
    "result": "pulse_grenade",
    "ingr": [2, "plasma_grenade", "obj_pulse_mod"]
  }, {
    "req": 3,
    "result": "dl19",
    "ingr": [4, "plasma_grenade", "unfail_cluster_bomb", "obj_napalm_cont", "obj_napalm_cont"]
  }, {
    "req": 0,
    "result": "unfail_cluster_bomb",
    "ingr": [2, "cluster_bomb", "obj_small_expl"]
  }, {
    "req": 1,
    "result": "air_strike",
    "ingr": [2, "cluster_bomb", "obj_radio"]
  }, {
    "req": 2,
    "result": "putty_grenade",
    "ingr": [3, "cluster_bomb", "obj_big_expl", "obj_laser_mod"]
  }, {
    "req": 1,
    "result": "banana_bomb",
    "ingr": [2, "cluster_bomb", "obj_laser_mod"]
  }, {
    "req": 3,
    "result": "banana_strike",
    "ingr": [4, "banana_bomb", "banana_bomb", "banana_bomb", "obj_radio"]
  }, {
    "req": 2,
    "result": "unfail_banana_bomb",
    "ingr": [2, "banana_bomb", "obj_small_expl"]
  }, {
    "req": 3,
    "result": "super_banana_bomb",
    "ingr": [4, "unfail_banana_bomb", "obj_laser_mod", "obj_small_expl", "obj_big_expl"]
  }, {
    "req": 3,
    "result": "mega_banana_bomb",
    "ingr": [4, "super_banana_bomb", "obj_plasma_mod", "obj_big_expl", "obj_big_expl"]
  }, {
    "req": 0,
    "result": "upg_mortar",
    "ingr": [2, "mortar", "obj_small_expl"]
  }, {
    "req": 2,
    "result": "nuclear_bomb",
    "ingr": [4, "upg_mortar", "obj_poison_cont", "obj_hard_jacket", "obj_big_expl"]
  }, {
    "req": 3,
    "result": "nuclear_bomb2",
    "ingr": [3, "nuclear_bomb", "obj_rad_cont", "obj_rad_cont"]
  }, {
    "req": 0,
    "result": "unfail_mine",
    "ingr": [2, "mine", "obj_small_expl"]
  }, {
    "req": 2,
    "result": "mine_strike",
    "ingr": [6, "mine", "mine", "mine", "mine", "mine", "obj_radio"]
  }, {
    "req": 0,
    "result": "fire_mine",
    "ingr": [2, "mine", "obj_napalm_cont"]
  }, {
    "req": 1,
    "result": "plasma_mine",
    "ingr": [2, "mine", "obj_plasma_mod"]
  }, {
    "req": 2,
    "result": "pulse_mine",
    "ingr": [2, "plasma_mine", "obj_pulse_mod"]
  }, {
    "req": 3,
    "result": "nuclear_mine",
    "ingr": [3, "unfail_mine", "pulse_mine", "obj_rad_cont"]
  }, {
    "req": 1,
    "result": "unfail_dynamite",
    "ingr": [2, "dynamite", "obj_small_expl"]
  }, {
    "req": 2,
    "result": "dynamite_bunch",
    "ingr": [4, "unfail_dynamite", "unfail_dynamite", "unfail_dynamite", "obj_small_expl"]
  }, {
    "req": 0,
    "result": "unfail_sheep",
    "ingr": [2, "sheep", "obj_small_expl"]
  }, {
    "req": 0,
    "result": "fire_sheep",
    "ingr": [2, "sheep", "obj_napalm_cont"]
  }, {
    "req": 0,
    "result": "poison_sheep",
    "ingr": [2, "sheep", "obj_poison_cont"]
  }, {
    "req": 2,
    "result": "mine_sheep",
    "ingr": [6, "unfail_sheep", "mine", "mine", "mine", "mine", "obj_hard_jacket"]
  }, {
    "req": 3,
    "result": "mine_sheep2",
    "ingr": [4, "mine_sheep", "plasma_mine", "obj_small_expl", "obj_hard_jacket"]
  }, {
    "req": 0,
    "result": "unfail_old_woman",
    "ingr": [2, "old_woman", "obj_small_expl"]
  }, {
    "req": 1,
    "result": "girder_pack",
    "ingr": [6, "girder", "girder", "girder", "girder", "girder", "girder"]
  }, {
    "req": 1,
    "result": "upg_teleport",
    "ingr": [2, "teleport", "obj_laser_mod"]
  }, {
    "req": 2,
    "result": "upg_teleport2",
    "ingr": [2, "upg_teleport", "obj_plasma_mod"]
  }, {
    "req": 2,
    "result": "emg_teleport",
    "ingr": [2, "upg_teleport", "obj_coil"]
  }, {
    "req": 2,
    "result": "upg_jet_pack",
    "ingr": [2, "jet_pack", "obj_fuel"]
  }, {
    "req": 3,
    "result": "ag_pack",
    "ingr": [2, "upg_jet_pack", "obj_eg_generator"]
  }, {
    "req": 1,
    "result": "power_axe",
    "ingr": [3, "battle_axe", "shocker", "obj_laser_mod"]
  }, {
    "req": 1,
    "result": "power_bat",
    "ingr": [3, "baseball_bat", "shocker", "obj_plasma_mod"]
  }, {
    "req": 1,
    "result": "hunting_rifle",
    "ingr": [2, "shotgun", "obj_middle_clip"]
  }, {
    "req": 2,
    "result": "napalm_strike",
    "ingr": [4, "molotov", "molotov", "molotov", "obj_radio"]
  }, {
    "req": 2,
    "result": "super_medikit",
    "ingr": [2, "medikit", "obj_small_cell"]
  }, {
    "req": 0,
    "result": "uzi",
    "ingr": [3, "pistol", "obj_barrel", "obj_middle_clip"]
  }, {
    "req": 1,
    "result": "unfail_uzi",
    "ingr": [2, "uzi", "obj_small_expl"]
  }, {
    "req": 1,
    "result": "minigun",
    "ingr": [3, "unfail_uzi", "obj_barrel", "obj_big_clip"]
  }, {
    "req": 2,
    "result": "unfail_minigun",
    "ingr": [2, "minigun", "obj_small_expl"]
  }, {
    "req": 2,
    "result": "air_minigun",
    "ingr": [3, "unfail_minigun", "obj_barrel", "obj_big_clip"]
  }, {
    "req": 3,
    "result": "avenger",
    "ingr": [3, "air_minigun", "obj_barrel", "obj_big_clip"]
  }, {
    "req": 3,
    "result": "laser_minigun",
    "ingr": [4, "air_minigun", "unfail_laser_rifle", "obj_big_cell", "obj_laser_mod"]
  }, {
    "req": 3,
    "result": "plasma_minigun",
    "ingr": [4, "air_minigun", "unfail_plasma_rifle", "obj_big_cell", "obj_plasma_mod"]
  }, {
    "req": 3,
    "result": "gauss_minigun",
    "ingr": [5, "air_minigun", "unfail_gauss_rifle", "obj_big_cell", "obj_coil", "obj_coil"]
  }, {
    "req": 1,
    "result": "laser_pistol",
    "ingr": [4, "pistol", "obj_small_cell", "obj_laser_mod", "obj_laser_mod"]
  }, {
    "req": 2,
    "result": "laser_pistol2",
    "ingr": [3, "laser_pistol", "obj_middle_clip", "obj_laser_mod"]
  }, {
    "req": 1,
    "result": "laser_rifle",
    "ingr": [4, "laser_pistol", "minigun", "obj_small_cell", "obj_laser_mod"]
  }, {
    "req": 2,
    "result": "unfail_laser_rifle",
    "ingr": [2, "laser_rifle", "obj_big_cell"]
  }, {
    "req": 1,
    "result": "plasma_pistol",
    "ingr": [4, "pistol", "obj_small_cell", "obj_plasma_mod", "obj_plasma_mod"]
  }, {
    "req": 1,
    "result": "plasma_rifle",
    "ingr": [4, "plasma_pistol", "minigun", "obj_small_cell", "obj_plasma_mod"]
  }, {
    "req": 2,
    "result": "unfail_plasma_rifle",
    "ingr": [2, "plasma_rifle", "obj_big_cell"]
  }, {
    "req": 1,
    "result": "gauss_pistol",
    "ingr": [4, "pistol", "obj_small_cell", "obj_coil", "obj_coil"]
  }, {
    "req": 2,
    "result": "gauss_pistol2",
    "ingr": [3, "gauss_pistol", "obj_middle_clip", "obj_coil"]
  }, {
    "req": 2,
    "result": "gauss_rifle",
    "ingr": [5, "gauss_pistol", "sniper_rifle", "obj_barrel", "obj_small_cell", "obj_coil"]
  }, {
    "req": 2,
    "result": "unfail_gauss_rifle",
    "ingr": [2, "gauss_rifle", "obj_big_cell"]
  }, {
    "req": 2,
    "result": "peacemaker",
    "ingr": [3, "sniper_rifle", "obj_middle_clip", "obj_small_expl"]
  }, {
    "req": 3,
    "result": "hearts_ace",
    "ingr": [2, "peacemaker", "obj_big_clip"]
  }, {
    "req": 2,
    "result": "rad_rifle",
    "ingr": [3, "sniper_rifle", "obj_barrel", "obj_rad_lock"]
  }, {
    "req": 2,
    "result": "bozar",
    "ingr": [4, "minigun", "sniper_rifle", "obj_barrel", "obj_middle_clip"]
  }, {
    "req": 2,
    "result": "bozar16",
    "ingr": [4, "bozar", "rad_rifle", "obj_middle_clip", "obj_rad_lock"]
  }, {
    "req": 3,
    "result": "bozar24s",
    "ingr": [3, "bozar16", "obj_barrel", "obj_big_clip"]
  }, {
    "req": 3,
    "result": "pulse_pistol",
    "ingr": [6, "laser_pistol", "plasma_pistol", "gauss_pistol", "obj_laser_mod", "obj_plasma_mod", "obj_coil"]
  }, {
    "req": 3,
    "result": "luiston",
    "ingr": [3, "pulse_pistol", "obj_big_cell", "obj_pulse_mod"]
  }, {
    "req": 3,
    "result": "de_lameter",
    "ingr": [4, "luiston", "obj_big_cell", "obj_pulse_mod", "obj_pulse_mod"]
  }, {
    "req": 3,
    "result": "turbo_rifle",
    "ingr": [4, "de_lameter", "unfail_laser_rifle", "unfail_plasma_rifle", "unfail_gauss_rifle"]
  }, {
    "req": 3,
    "result": "orbit_strike",
    "ingr": [4, "luiston", "luiston", "luiston", "obj_radio"]
  }, {
    "req": 3,
    "result": "ultra_rifle",
    "ingr": [3, "pulse_pistol", "obj_barrel", "obj_ultra_mod"]
  }, {
    "req": 3,
    "result": "vindicator",
    "ingr": [4, "ultra_rifle", "obj_barrel", "obj_big_clip", "obj_ultra_mod"]
  }, {
    "req": 3,
    "result": "kenton_bazooka",
    "ingr": [4, "ap_bazooka2", "ap_bazooka2", "nuclear_bomb", "obj_ultra_mod"]
  }, {
    "req": 3,
    "result": "kenton_grenade",
    "ingr": [4, "dl19", "dl19", "super_hhg", "obj_ultra_mod"]
  }, {
    "req": 3,
    "result": "void_melody",
    "ingr": [5, "turbo_rifle", "laser_minigun", "plasma_minigun", "gauss_minigun", "obj_ultra_mod"]
  });
}
